import React, { useEffect, useState } from "react";
import { api } from "@/api";
import { useLang } from "@/i18n";
import Seo from "@/components/Seo";
import { ArticleCard } from "@/components/ArticleCard";

const CATS = ["All", "Guide", "Technique", "Review", "History", "Curiosity"];

export default function Articles() {
  const { lang, t } = useLang();
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/articles", { params: { lang } }).then((r) => setArticles(r.data));
  }, [lang]);

  const filtered = cat === "All" ? articles : articles.filter((a) => a.category === cat);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <Seo title={lang === "it" ? "Articoli e guide di boxe e kickboxing" : "Boxing & kickboxing articles and guides"} description={lang === "it" ? "Tecnica, storia, curiosità e allenamento: tutte le guide di Guardia su boxe e kickboxing." : "Technique, history, curiosities and training: every Guardia guide on boxing and kickboxing."} />
      <span className="text-xs font-mono uppercase tracking-[0.25em] text-[#E63946]">{t("nav_articles")}</span>
      <h1 className="mt-2 font-heading text-4xl sm:text-5xl font-black uppercase text-white">{t("nav_articles")}</h1>

      <div className="mt-6 flex flex-wrap gap-2">
        {CATS.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c}`}
            onClick={() => setCat(c)}
            className={`px-4 py-1.5 text-sm font-semibold rounded-full border transition-colors ${
              cat === c ? "bg-[#E63946] border-[#E63946] text-white" : "border-[#272b35] text-zinc-400 hover:text-white"
            }`}
          >
            {c === "All" ? t("all_categories") : c}
          </button>
        ))}
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </div>
  );
}
